<template>

  <v-container fluid>

    <v-layout>

      <v-flex>

        <div class="d-flex mb-4">

          <h1 class="display-1">
            Service Wizard
          </h1>

          <v-spacer></v-spacer>

          <v-btn outlined color=""
                 @click="clear"
                 x-large to="/wizard" width="250">
            <v-icon left>mdi-restart</v-icon>
            Start Over
          </v-btn>

        </div>

        <v-sheet color="primary white--text" class="my-3 pa-4" v-if="step">
          <h3 class="title text-uppercase">
            {{category}} Service
          </h3>
        </v-sheet>

        <router-view class="">

          <template v-slot:back-next>

            <v-container fluid grid-list-md>

              <v-layout class="">

                <v-flex>
                  <v-btn block depressed color="accent black--text" @click="decrementStep" large
                         :disabled="step < 2">
                    <v-icon left>mdi-chevron-left</v-icon>
                    Previous
                  </v-btn>
                </v-flex>

                <v-flex>
                  <v-btn block depressed color="accent black--text" @click="incrementStep" large>
                    Next
                    <v-icon right>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-flex>

              </v-layout>

            </v-container>

          </template>

        </router-view>

      </v-flex>

    </v-layout>

  </v-container>

</template>

<script>
import WizardMixin from '../views/Wizard.Mixin';

export default {

  name: 'WizardRoot',

  mixins: [WizardMixin],

  components: {},

  data() {
    return {
      curStep: 1,
      totalSteps: 4,
    };
  },

  mounted() {
    if (!this.$store.state.wizard.preferences.useCategory.value) {
      this.$store.dispatch('setPreferences', {
        ...this.$store.state.wizard.preferences,
        useCategory: this.useCategories[0],
      });
    }
    if (this.step) {
      this.curStep = this.step;
    }
    this.totalSteps = this.category === 'residential' ? 4 : 4;
  },

  computed: {

    useCategories() {
      return this.$store.getters.models.useCategories;
    },

    category() {
      return this.$store.state.wizard.preferences.useCategory.value;
    },

    // selections() {
    //   return this.$store.state.wizard.selections;
    // },

  },

  methods: {

    clear() {
      this.$store.dispatch('resetPreferences');
    },

    selecUseCategory(item) {
      this.$store.dispatch('setPreferences', {
        ...this.$store.state.wizard.preferences,
        useCategory: item,
      });

      this.$router.push({
        name: `wizard-${item.value}`,
        query: {
          step: 1,
        }
      });
    },

  },

  watch: {

    category(category) {
      this.totalSteps = category === 'residential' ? 4 : 4;
    },

  },

};

</script>
